import { useRef } from 'react';
import { useIntersection } from 'react-use';
const useIsIntersecting = () => {
    const intersectionRef = useRef();
    const { isIntersecting } = useIntersection(intersectionRef, {
        root: null,
        rootMargin: '0px',
        threshold: 1,
    }) || {};
    return {
        intersectionRef,
        isIntersecting,
    };
};
export default useIsIntersecting;
